import { maybeParseDate } from '@/utils/date-util'
import { safeTimestampToDate, timestampToISO } from '@/utils/grpc-util'
import { type GetTxfJobResponse as TxfJobProto } from '@taxfyle/api-internal/internal/txf_pb'
import type { TxfJobProps } from './TxfJob'

export function mapTxfJobProtoToProps(
  jobId: string,
  proto: TxfJobProto,
): TxfJobProps {
  return {
    jobId,
    createdAt: safeTimestampToDate(proto.getCreateTime()),
    modifiedAt: safeTimestampToDate(proto.getUpdateTime()),
    onboardingState: {
      readyToOnboard: proto.getOnboardingState()?.getReadyToOnboard() ?? false,
      inactivityGracePeriodExpiresAt: maybeParseDate(
        timestampToISO(
          proto.getOnboardingState()?.getInactivityGracePeriodExpireTime(),
        ),
      ),
    },
  }
}
